import { DeviceType } from '@provider-portal/common/styles/useThemeHooks';
import { createReducer } from 'typesafe-actions';

import { setDeviceType, ThemeActions } from 'rdx/theme/actions';

export interface ThemeState {
  deviceType: DeviceType;
}

export const initialState: Readonly<ThemeState> = {
  deviceType: 'desktop',
};

function updateDeviceTypeState(state: ThemeState, action: ThemeActions): ThemeState {
  const targetDeviceType = action.payload;
  if (state.deviceType === targetDeviceType) {
    return state;
  }

  return { ...state, deviceType: targetDeviceType };
}

export const themeReducer = createReducer<ThemeState, ThemeActions>(initialState).handleAction(
  setDeviceType,
  updateDeviceTypeState,
);
